/**
 * Generic params
 */
export function KubernetesCommonParams() {
  return {
    id: '',
  };
}
